import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { eventConfigAll } from "@/api/config";
export var gameEvent = {
  namespaced: true,
  state: {
    isInit: 0,
    eventKv: {}
  },
  mutations: {
    setEventkKv: function setEventkKv(state, eventMap) {
      state.isInit = 1;
      state.eventKv = eventMap;
    }
  },
  actions: {
    getEvent: function getEvent(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var commit, state, res, eventMap;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              if (!(state.isInit == 0)) {
                _context.next = 6;
                break;
              }
              _context.next = 4;
              return eventConfigAll();
            case 4:
              res = _context.sent;
              if (res.code == 0) {
                eventMap = {};
                res.data.forEach(function (val) {
                  eventMap[val.eventId] = val.eventName;
                });
                commit("setEventkKv", eventMap);
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  //派生状态
  getters: {
    eventMap: function eventMap(state) {
      return state.eventKv;
    }
  }
};